// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_9i-3";
export var contentContainer = "_9i-0";
export var editorContainer = "_9i-1";
export var quillInputForm = "_9i-2";
export var zoneDivider = "_9i-4";